import clsx from 'clsx';
import { CircleCheck } from 'lucide-react';
import { formatPriceWithEuro } from '../../utils/StringUtils';
import { calculateTotalToPay } from '../../utils/order/orderUtils';

export const Header = ({ cartItems, badgeVisible }) => (
  <div
    className={clsx(
      'inline-flex items-center gap-2 bg-green-500/20 text-green-400 py-2.5 px-[25px] rounded-full text-base font-semibold tracking-[0.2px] transition-all duration-500 ease-out w-fit',
      badgeVisible
        ? 'opacity-100 translate-y-0'
        : 'opacity-0 -translate-y-3',
    )}
  >
    <CircleCheck size={18} fill="#4ade80" color="white" strokeWidth={2.5} />
    Paiement réussi •{' '}
    {formatPriceWithEuro(
      calculateTotalToPay(
        cartItems?.itemsPrice ?? 0,
        cartItems?.promoPrice ?? 0,
        cartItems?.jackpot?.amount,
      ),
    )}
  </div>
);
